import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Add auth token interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('dns_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('dns_admin_token');
      localStorage.removeItem('dns_admin_user');
      if (window.location.pathname.startsWith('/admin') && !window.location.pathname.includes('/admin/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Public APIs
export const publicApi = {
  getJobs: () => api.get('/jobs'),
  getJob: (id) => api.get(`/jobs/${id}`),
  submitContact: (data) => api.post('/contacts', data),
  healthCheck: () => api.get('/health'),
};

// Auth APIs
export const authApi = {
  login: (credentials) => api.post('/auth/login', credentials),
};

// Admin APIs
export const adminApi = {
  getContacts: (page = 1, limit = 20) => api.get(`/admin/contacts?page=${page}&limit=${limit}`),
  getContactsCount: () => api.get('/admin/contacts/count'),
  markContactRead: (id) => api.patch(`/admin/contacts/${id}/read`),
  deleteContact: (id) => api.delete(`/admin/contacts/${id}`),
  getJobs: (page = 1, limit = 20) => api.get(`/admin/jobs?page=${page}&limit=${limit}`),
  createJob: (data) => api.post('/admin/jobs', data),
  updateJob: (id, data) => api.put(`/admin/jobs/${id}`, data),
  deleteJob: (id) => api.delete(`/admin/jobs/${id}`),
};

export default api;
